var initializeBlock = function(block){
    
    setupJobSearch(block);
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-openings').each(function(){
        initializeBlock(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=openings', initializeBlock);


function setupJobSearch(block){
	
	jQuery(block).on('click', '.job-filter', function(e){
		
		e.preventDefault();
		
		const current = jQuery(this);
		const tax = current.attr('data-tax');
		const taxID = current.attr('data-tax-id');
		const dummySearchTerm = current.attr('data-dummy-search');
		
		jQuery('#job-search-text').val('');
		
		searchJobs(tax, taxID, '', dummySearchTerm);
		
	});
	
	jQuery('#job-search').on('submit', function(e){
		
		e.preventDefault();
		
		searchJobs('', '', jQuery('#job-search-text').val());
		
	});
	
}

function searchJobs(tax = '', taxID = '', searchTerm = '', dummySearchTerm = ''){
	
	jQuery.ajax({
		url:"/wp-admin/admin-ajax.php",
		type:'POST',
		data:'action=filter_jobs&tax=' + tax + '&tax_id=' + taxID + '&search_term=' + searchTerm + '&dummy_search_term=' + dummySearchTerm,
		success:function(results){
			
			jQuery('#job-openings').html(results);
			
		}
	});
	
}
